const MailHtml = () => {
  return (
    <div
      id="bodyStyle"
      style={{
        border: "3px solid #e0e0e0",
        width: "50%",
        margin: "auto",
        backgroundColor: "#fffefe",
        color: "#424242",
      }}
    >
      <div
        id="headerStyle"
        style={{
          height: "50px",
          textAlign: "center",
          backgroundColor: "#9b9484",
          color: "#c4bcac",
        }}
      >
        <h1>ระบบประเมินนักศึกษาแพทย์</h1>
      </div>
      <div id={"content"} style={{ textAlign: "center" }}>
        <p
          style={{ fontSize: "20px" }}
        >{`รหัสเพื่อเข้าสู่ระบบแบบประเมินนักศึกษาแพทย์`}</p>
        <p
          style={{ fontSize: "20px", fontWeight: "bold" }}
        >{`รหัสยืนยันตัวตน :  `}</p>
        <p>
          {`เข้าสู่ระบบ : `}
          <a
            href="http://localhost:3000/"
            style={{ color: "#607d8b", fontSize: "20px" }}
          >
            คลิก
          </a>
        </p>
      </div>
      <div
        id="footerStyle"
        style={{
          height: "30px",
          textAlign: "center",
          backgroundColor: "#e0e0e0",
        }}
      ></div>
    </div>
  );
};
export default MailHtml;
